import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2 className='text-center text-primary'>404 not found !!!</h2>
        </div>
    );
};

export default NotFound;